import { PplDispatchPoint } from '@pages/order/payment-shipping/ppl-script/PplDispatchPoint';



export interface PplParcelshopEvent extends CustomEvent {
	detail: PplDispatchPoint;
}


export function isPplParcelshopEvent(event: Event): event is PplParcelshopEvent {
	return event.type === 'ppl-parcelshop-map' && 'detail' in event;
}